import { getInitialLaunchUrl, removeOhswAuthorizeUrl, setInitialLaunchUrl } from './utils/storage-utils';
import { getClientId } from './utils/widget-facade';
import { withErrorConsumed } from './utils/common-utils';
import { launchedFromLwaProfile } from './utils/lwa-profile-utils';
import { launchedFromAthenanetUserProfile } from './utils/athenanet-user-profile-utils';

const updateUrlBasedOnClientId = (clientId: string) => {
  const ohswAuthorizeUrl = getInitialLaunchUrl();
  if (ohswAuthorizeUrl) {
    const parsedUrl = new URL(ohswAuthorizeUrl);
    const clientIdFromUrl = parsedUrl.searchParams.get('client_id');
    if (clientIdFromUrl !== clientId) {
      removeOhswAuthorizeUrl();
    }
  }
};

const updateInitialLaunchUrl = withErrorConsumed(() => {
  if (window.location.pathname.endsWith('v1/authorize') || launchedFromLwaProfile() || launchedFromAthenanetUserProfile()) {
    setInitialLaunchUrl(window.location.href);
  }
  else {
    const requestContext = global.OktaUtil.getRequestContext();
    const clientId = getClientId(requestContext);
    if (clientId) {
      updateUrlBasedOnClientId(clientId);
    }
    else {
      removeOhswAuthorizeUrl();
    }
  }
});

export default function rewriteUrlOnChange() {
  updateInitialLaunchUrl();
}
